import { csoSzakaszok, type CsoBemenet } from './csoSav.ts';

export interface CsoSavProps {
  /** A szakaszok sorrendben; a szélesség a `db`-val arányos. */
  szakaszok: readonly (CsoBemenet & { cimke: string })[];
  /** A kiválasztott szakasz kulcsa (keretet kap). */
  kivalasztott?: string | null;
  /** Kattintásra a szakasz kulcsával hívódik; ha hiányzik, a szakaszok nem kattinthatók. */
  onValaszt?(kulcs: string): void;
  /** A sáv akadálymentes neve. */
  nev: string;
}

/** A csővezeték-sávmérő: az oldal egyetlen hangos eleme. */
export default function CsoSav({ szakaszok, kivalasztott, onValaszt, nev }: CsoSavProps) {
  const adatok = csoSzakaszok(szakaszok, kivalasztott);
  return (
    <div role="group" aria-label={nev} className="flex h-14 gap-[3px] overflow-hidden rounded-[14px] bg-hatter-melyen md:h-16 md:rounded-2xl">
      {adatok.map((sz, i) => {
        const cimke = szakaszok[i]!.cimke;
        return (
          <button
            key={sz.kulcs}
            type="button"
            disabled={!onValaszt}
            aria-pressed={onValaszt ? sz.kivalasztva : undefined}
            aria-label={`${sz.db} ${cimke}`}
            title={`${sz.db} ${cimke}`}
            onClick={() => onValaszt?.(sz.kulcs)}
            style={sz.jel ? { flex: '0 0 6px', background: sz.szin } : { flexGrow: sz.flex, flexBasis: 0, background: sz.szin }}
            className={`flex flex-col justify-center overflow-hidden text-left text-kiemelt-szoveg ${sz.jel ? 'min-w-0 px-0 opacity-60' : 'min-w-11 px-2.5 md:min-w-16 md:px-4'} ${sz.kivalasztva ? 'outline-2 -outline-offset-2 outline-szoveg' : ''} ${onValaszt ? 'cursor-pointer' : 'cursor-default'}`}
          >
            {!sz.jel && (
              <>
                <b className="text-xl leading-none font-semibold tracking-[-0.03em] md:text-2xl">{sz.db}</b>
                {!sz.kompakt && <span aria-hidden className="mt-0.5 hidden overflow-hidden text-xs font-medium text-ellipsis whitespace-nowrap opacity-80 md:block">{cimke}</span>}
              </>
            )}
          </button>
        );
      })}
    </div>
  );
}
